<template>
  <div class="app-container" style="padding: 0 20px 0 0">
    <div class="filter-container">
      <component v-for="(item) in headFields"
        v-if="typeof item.visible === 'function' ? item.visible(item) : (typeof item.visible == 'undefined' || item.visible)"
        v-bind:is="item.component?item.component:'el-input'"
        :key="item.name"
        :item="item"
        v-model="listQuery[item.name]"
      />
    </div>
    <div class="filter-container">
      <component v-for="(item, i) in searchFields"
        v-if="(typeof item.visible === 'function' ? item.visible(item) : (typeof item.visible == 'undefined' || item.visible)) && (advancedSearch ? (i <= 3) : true)"
                 v-bind:is="item.component?item.component:'el-input'"
        :key="item.name"
        :item="item"
        v-model="listQuery[item.name]"
        :placeholder="typeof item.label === 'string' ? $t(item.label) : item.label"
        :config="typeof item.config == 'function' ? item.config(temp) : item.config"
        style="width: auto;margin-right: 10px;"
        class="filter-item"
        @change="onChange"
        clearable />
<!--      <el-switch-->
<!--        v-model="lookMe"-->
<!--        v-if="showLookMe"-->
<!--        active-text="只看我的"-->
<!--        inactive-text="">-->
<!--      </el-switch>-->
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('table.search') }}</el-button>
      <el-button v-if="showReload" class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-refresh" @click="onLoad">{{ $t('table.reload') }}</el-button>
      <el-button v-if="addable" class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="handleCreate">{{ $t('table.add') }}</el-button>
      <el-button v-for="item in buttons" :size="item.size" :key="item.name" :class="item.cls ? item.cls : 'filter-item'" v-if="typeof item.visible === 'function' ? item.visible(item) : (typeof item.visible === 'undefined' || item.visible)" style="margin-left: 10px" :type="item.type ? item.type : 'success'" plain :icon="item.icon" @click="item.handle($data)" >{{ $t(item.label) }}</el-button>
      <el-button v-if="showAdvancedSearch" @click="advancedSearch = !advancedSearch" type="primary" plain class="filter-item">{{ $t('table.advanced_search') }}</el-button>
    </div>
    <component v-bind:is="panel" :summary="panelData" />
    <el-table
      show-overflow-tooltip
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      :show-summary="sumable"
      :sum-text="sumText"
      :summary-method="summaryMethod"
      @sort-change="sortChange"
      class="tableBox"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="selectable"
        type="selection"
        width="55"
        align="center"
        fixed="left"
      />
      <el-table-column v-if="(actions && actions.length>0) || editable || removable" :label="$t('table.actions')" align="center" class-name="small-padding fixed-width actions" :width="(actions ? actions.length : 0) + 50" fixed="left">
        <template slot-scope="scope">
          <el-dropdown placement="bottom-start" trigger="click">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--left" style="color: #2e6da4"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="action in actions" :key="action.id" :item="action">
                <div style="width: 100%;height: 100%;text-align: center;font-weight: 500" v-if= "typeof action.visible === 'function' ? action.visible(scope.row) : (typeof action.visible === 'undefined' || action.visible)"
                      :size="action.size"
                      :type="(typeof action.type === 'function' ) ? action.type(scope.row) : action.type"
                      @click="action.handle(scope.row)" >
                  {{ $t(typeof action.label === 'function' ? action.label(scope.row) : action.label) }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div style="width: 100%;height: 100%;text-align: center;color: #2C8DFB" v-if="editable" type="primary" size="mini" @click="handleUpdate(scope.row)">{{ $t('table.edit') }}</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div style="width: 100%;height: 100%;text-align: center;color: red" v-if="removable" type="danger" size="mini" @click="handleDelete(scope.row)">{{ $t('table.delete') }}</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column v-if="expand" type="expand" align="center">
        <template slot-scope="scope">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item v-for="item in expandFields" :key="item.name" :item="item" :label="$t(item.label)" class="expand-item">
              <span>{{ item.key ? (scope.row[item.name] ? scope.row[item.name][item.key] : '') : scope.row[item.name] }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column v-for="item in currentFields" :key="item.name" v-if="typeof item.visible === 'function' ? item.visible(item) : (typeof item.visible === 'undefined' || item.visible)" :item="item" :label="$t(item.label)" :prop="item.name" :width="columnWidth[item.width] ? columnWidth[item.width] : item.width" align="center" :formatter="item.formatter" :sortable="item.sort" >
        <template slot-scope="scope">
          <el-tooltip
            :content="item.ellipsis ? getColumnData(scope.row, item) : ''"
            :disabled="!item.ellipsis"
            placement="top"
          >
            <div :class="{'ellipsis-cell': item.ellipsis}">
              <component
                v-bind:is="item.template ? item.template : 'span'"
                v-html="item.template ? null : getColumnData(scope.row, item)"
                :class="getColumnClass(scope.row, item)"
              />
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" style="padding: 0" />

    <el-dialog :title="$t(textMap[dialogStatus])" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left">
        <el-form-item v-for="item in editFields"
          :key="item.name"
          :item="item"
          :prop="item.name"
          :rules="rules?rules[item.name]:null"
          :label="$t(item.label)"
          v-if="(item.initiable===undefined?true:(dialogStatus==='update')) && (typeof item.visible === 'function' ? item.visible(item, temp) : (typeof item.visible === 'undefined' || item.visible))"
        >
          <div v-if="item.component==='user-password-input'" style="height:0px" >
            <input type="text" />
            <input type="password" />
          </div>
          <component
            :clearable="item.component === 'el-input'"
            :disabled="dialogStatus==='update' && item.disabled"
            v-bind:is="typeof item.component === 'function' ? item.component(temp) : item.component"
            v-model="temp[item.name]"
            :config="typeof item.config == 'function' ? item.config(temp) : item.config"
            v-bind:readonly="item.readonly && dialogStatus==='update'" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">{{ $t('table.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import waves from '@/directive/waves' // Waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import {getPropByPath} from 'element-ui/src/utils/util'
import global from '../../card/components/global/index.vue'

export default {
  name: 'TableView',
  components: { Pagination },
  directives: { waves },
  inject: ['reload'],
  data () {
    return {
      multipleSelection: [],
      columnWidth: global.width,
      currentFields: this.fields,
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      advancedSearch: true,
      // lookMe: false,
      listQuery: {
        page: 1,
        limit: 10,
        q: ''
      },
      temp: {
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: 'dialog.Edit',
        create: 'dialog.Create'
      },
      rules: this.rule ? this.rule : this.getRule()
    }
  },
  props: {
    // 控制是否启用多选框
    selectable: {
      type: Boolean,
      default: false
    },
    repo: {},
    pk: {},
    panel: {
      type: String,
      default: 'div'
    },
    panelData: {},
    fields: {},
    expand: { type: Boolean, default: false },
    expandFields: {},
    editFields: {},
    searchFields: {},
    headFields: {},
    showAdvancedSearch: false,
    actions: {},
    beforeAdd: {
      type: Function,
      default: (d) => { return d }
    },
    beforeUpdate: {
      type: Function,
      default: (d) => { return d }
    },
    beforeDelete: {
      type: Function,
      default: null
    },
    addable: {
      type: Boolean,
      default: true
    },
    showReload: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    rule: Object,
    removable: {},
    buttons: {},
    sumable: {
      type: Boolean,
      default: false
    },
    sumText: '',
    summaryMethod: {}
    // showLookMe: false
  },
  created () {
    this.advancedSearch = this.showAdvancedSearch
    this.getList()
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.$emit('selection-change', val) // 可选：往上传
    },
    getRule () {
      const validator = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('rule.error')))
        }
        callback()
      }
      let data = {}
      data.ConverTypes = [{ validator: validator, trigger: 'change' }]
      for (let i = 0; i < this.editFields.length; i++) {
        data[this.editFields[i].name] = [{ required: !!this.editFields[i].required, message: this.$t('rule.' + this.editFields[i].name), trigger: 'change' }]
      }
      return data
    },
    getColumnData (row, column) {
      return column.formatter ? column.formatter(row, column) : getPropByPath(row, column.name).v
    },
    getColumnClass (row, column) {
      return (typeof column.cls === 'function') ? column.cls(row) : (typeof column.cls === 'string' ? column.cls : '')
    },
    getList () {
      console.log(this.listQuery)
      this.listLoading = true
      let q = []
      // if (this.lookMe) {
      //   q.push(['=', 'lookMe', this.lookMe)
      // }
      this.listQuery.q = q.join('&')
      this.repo.fetchList(this.listQuery).then(response => {
        this.list = response.data
        this.total = response.total
        if (!this.total) {
          this.total = response.data.length
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      this.listQuery.page = 1
      this.getList()
    },
    handleModifyStatus (row, status) {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      row.status = status
    },
    sortChange (data) {
      const { prop, order } = data
      this.sortByID(prop, order)
    },
    sortByID (prop, order) {
      if (prop !== null) {
        if (order === 'ascending') {
          this.listQuery.sort = '+' + prop
        } else {
          this.listQuery.sort = '-' + prop
        }
      } else {
        this.listQuery.sort = null
      }
      this.handleFilter()
    },
    resetTemp () {
      this.temp = {
      }
    },
    locData (d, key) {
      let p = key.indexOf('.')
      if (p < 0) {
        return d[key]
      }
      let k1 = key.substring(0, p)
      return this.locData(d[k1], key.substring(p + 1))
    },
    handleCreate () {
      this.resetTemp()
      if (this.beforeAdd) {
        this.temp = this.beforeAdd(this.temp)
      }
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.busy.$emit('loading', true)
          this.repo.create(this.temp).then((res) => {
            if (res !== false) {
              this.busy.$emit('loading', false)
              this.list.unshift(this.temp)
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              })
              this.getList()
            } else {
              this.busy.$emit('loading', false)
              // this.dialogFormVisible = false
            }
          }).catch(() => {
            this.busy.$emit('loading', false)
          })
        }
      })
    },
    handleUpdate (row) {
      this.temp = Object.assign({}, row)
      if (this.beforeUpdate) {
        this.temp = this.beforeUpdate(this.temp) // copy obj
      }
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      this.getList()
    },
    updateData () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.busy.$emit('loading', true)
          this.repo.update(this.temp).then(() => {
            for (const v of this.list) {
              if (v[this.pk] === this.temp[this.pk]) {
                const index = this.list.indexOf(v)
                this.list.splice(index, 1, this.temp)
                break
              }
            }
            this.busy.$emit('loading', false)
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          }).catch(() => {
            this.busy.$emit('loading', false)
          })
        }
      })
    },
    handleDelete (row) {
      if (!this.beforeDelete || this.beforeDelete(row)) {
        this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.busy.$emit('loading', true)
          this.repo.delete(row).then(() => {
            this.busy.$emit('loading', false)
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          }).catch(() => {
            this.busy.$emit('loading', false)
          })
        })
      }
    },
    onChange (value) {
      // console.log(value)
    },
    onLoad () {
      this.reload()
    }
  }
}
</script>

<style lang="scss">
/* 添加省略号样式 */
.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.expand-item {
  min-width: 12em;
}
@media screen and (max-width: 800px) {
  .el-dialog {
    width: 75%;
  }
}
@media screen and (max-width: 400px) {
  .el-dialog {
    width: 100%;
  }
}
.el-select {
  width: 100%;
}
.actions .el-button {
  margin: 0 5px;
}
.red {
  border-radius: 4px;
  background: #f33;
  padding: 2px 15px;
  color: #fff;
}
.green {
  border-radius: 4px;
  background: #0b0;
  padding: 2px 15px;
  color: #fff;
}
.blue {
  border-radius: 4px;
  background: #09f;
  padding: 2px 15px;
  color: #fff;
}

.gray {
  border-radius: 4px;
  background: #999;
  padding: 2px 15px;
  color: #eee;
}

.tableBox {
  //border-radius: 4px;
  font-size: 13px;
  color: #333333;
  p{
    margin: 8px 0 !important;
  }
  th{
    padding: 0 !important;
    height: 40px;
    line-height: 40px;
    color: #333;
    text-align: center;
    background: #f8f8f8;
    /*background-color: rgba(7,20,90,0.6);
    /*background: linear-gradient(to top, #f2f8ff , #afddfb);*/
    /*background: linear-gradient(to top, #f7f7f7 , #e7e7e7);*/
  }
  td{
    padding: 0 !important;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
// 修改dialog heard背景色
//.el-dialog__header{
//  border-top-left-radius: 5px;
//  border-top-right-radius: 5px;
//  background: linear-gradient(to top, #f7f7f7 , #e7e7e7);
//}
.el-dialog{
   border-radius: 5px;
 }
// 操作菜单
.el-dropdown-menu__item{
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TableView/index.vue